import * as d3 from 'd3'
import { feature } from 'topojson-client'
import { getMapCenter, getMapScale, LABEL_OFFSETS } from './constants'

// 地圖渲染類
export class MapRenderer {
  constructor (container, topoData) {
    this.container = container
    this.topoData = topoData
    this.width = container.clientWidth
    this.height = container.clientHeight
    this.geoData = feature(topoData, topoData.objects.layer1)

    // 清空容器
    this.container.innerHTML = ''

    // 創建 SVG
    this.svg = d3.create('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('class', 'map-svg')

    this.g = this.svg.append('g')
  }

  // 初始化地圖投影和路徑
  initializeProjection () {
    this.projection = d3.geoMercator().fitSize([this.width, this.height], this.geoData)
    this.path = d3.geoPath().projection(this.projection)
    return { projection: this.projection, path: this.path }
  }

  // 繪製縣市路徑
  drawCountyPaths () {
    const countyPaths = this.g.selectAll('path')
      .data(this.geoData.features)
      .join('path')
      .attr('d', this.path)
      .attr('fill', '#404457')
      .attr('stroke', '#6A7091')
      .attr('stroke-width', 0.5)
      .attr('stroke-linecap', 'round')
      .attr('stroke-linejoin', 'round')
      .attr('class', d => `county-path county-${d.properties.ENGLISHNAME}`)

    return countyPaths
  }

  // 創建圖標圖層
  createIconLayer () {
    return this.g.append('g').attr('class', 'site-icons')
  }

  // 計算初始變換
  calculateInitialTransform () {
    const windowWidth = window.innerWidth
    const targetCenter = getMapCenter(windowWidth)

    const bounds = d3.geoPath(this.projection).bounds(this.geoData)
    const dx = bounds[1][0] - bounds[0][0]
    const dy = bounds[1][1] - bounds[0][1]

    const scale = getMapScale(windowWidth, this.width, this.height, dx, dy)

    const geoCenter = {
      x: (bounds[0][0] + bounds[1][0]) / 2,
      y: (bounds[0][1] + bounds[1][1]) / 2
    }

    const translateX = targetCenter.x - geoCenter.x * scale
    const translateY = targetCenter.y - geoCenter.y * scale

    const initialTransform = d3.zoomIdentity
      .translate(translateX, translateY)
      .scale(scale)

    this.g.attr('transform', initialTransform)
    return initialTransform
  }

  // 繪製縣市標籤
  drawCountyLabels () {
    const labels = this.geoData.features
      .filter(d => d.geometry && d.geometry.type)
      .map(d => {
        const [x, y] = this.path.centroid(d)
        const offset = LABEL_OFFSETS[d.properties.COUNTYNAME] || { x: 0, y: 0 }
        return {
          x: x + offset.x,
          y: y + offset.y,
          name: d.properties.COUNTYNAME
        }
      })
      .filter(d => !isNaN(d.x) && !isNaN(d.y))

    // 使用力模擬避免標籤重疊
    const simulation = d3.forceSimulation(labels)
      .force('x', d3.forceX(d => d.x).strength(1))
      .force('y', d3.forceY(d => d.y).strength(1))
      .force('collide', d3.forceCollide(20))
      .stop()

    simulation.alpha(1).restart()
    setTimeout(() => simulation.stop(), 100)

    this.g.selectAll('text')
      .data(labels)
      .join('text')
      .attr('x', d => d.x)
      .attr('y', d => d.y)
      .text(d => d.name)
      .attr('class', 'town-label')
      .attr('text-anchor', 'middle')
      .attr('pointer-events', 'none')
      .attr('fill', '#6e748f')
    return labels
  }

  // 將 SVG 添加到容器
  appendToContainer () {
    this.container.appendChild(this.svg.node())
  }

  // 獲取 SVG 和 G 元素
  getElements () {
    return {
      svg: this.svg,
      g: this.g,
      width: this.width,
      height: this.height
    }
  }
}
